
    <div class="openproject-base--ui-view">
      <ui-view></ui-view>
    </div>
  